import React from "react";
import { Instagram, Facebook, Mail, Phone } from "lucide-react";

export default function Footer() {
  return (
    <footer
      data-testid="footer"
      className="bg-[#2D2926] text-[#FDFBF7]/80 py-16 px-6 md:px-12 lg:px-16"
    >
      <div className="max-w-7xl mx-auto grid md:grid-cols-12 gap-10 md:gap-8">
        <div className="md:col-span-5">
          <div className="flex items-baseline gap-2 mb-6">
            <span className="font-serif text-3xl tracking-tight text-[#FDFBF7]">Derma</span>
            <span className="eyebrow text-[#D4A373]">Aesthetic Studio</span>
          </div>
          <p className="text-sm font-light leading-relaxed max-w-md mb-8">
            A boutique nurse-led studio in Daisy Hill, Queensland — offering integrated health
            and skin care across aesthetics, medical weight management, women's wellness and
            hair &amp; scalp therapy.
          </p>
          <div className="flex gap-4">
            <a
              href="https://instagram.com"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-instagram"
              className="w-10 h-10 rounded-full border border-[#FDFBF7]/15 flex items-center justify-center hover:bg-[#C89F95] hover:border-[#C89F95] transition-colors"
              aria-label="Instagram"
            >
              <Instagram size={16} strokeWidth={1.5} />
            </a>
            <a
              href="https://facebook.com"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-facebook"
              className="w-10 h-10 rounded-full border border-[#FDFBF7]/15 flex items-center justify-center hover:bg-[#C89F95] hover:border-[#C89F95] transition-colors"
              aria-label="Facebook"
            >
              <Facebook size={16} strokeWidth={1.5} />
            </a>
          </div>
        </div>

        <div className="md:col-span-3">
          <p className="eyebrow text-[#D4A373] mb-5">Studio</p>
          <ul className="space-y-3 text-sm">
            <li>75 Daisy Hill Rd</li>
            <li>Daisy Hill QLD 4127</li>
            <li>Tue – Sat · 9am – 5pm</li>
            <li>By appointment only</li>
          </ul>
        </div>

        <div className="md:col-span-4">
          <p className="eyebrow text-[#D4A373] mb-5">Contact</p>
          <ul className="space-y-3 text-sm">
            <li className="flex items-center gap-3">
              <Phone size={14} strokeWidth={1.5} />
              <a href="tel:0459830505" className="hover-line">0459 830 505</a>
            </li>
            <li className="flex items-center gap-3">
              <Mail size={14} strokeWidth={1.5} />
              <a href="mailto:info@dermaaestheticstudio.com" className="hover-line">
                info@dermaaestheticstudio.com
              </a>
            </li>
          </ul>
        </div>
      </div>

      <div className="max-w-7xl mx-auto mt-16 pt-8 border-t border-[#FDFBF7]/10 flex flex-col md:flex-row justify-between gap-4 text-xs text-[#FDFBF7]/50">
        <p>© 2026 Derma Aesthetic Studio · Integrated Health &amp; Skin</p>
        <p className="eyebrow">Crafted in Queensland</p>
      </div>
    </footer>
  );
}
